import { Network } from '@capacitor/network';

export const networkConnected = async (): Promise<boolean> => {
  const networkStatus = await Network.getStatus();
  return networkStatus.connected;
};
